<button
  #tabEl
  [attr.aria-selected]="active"
  [attr.aria-controls]="panel"
  [id]="id"
  role="tab"
  [tabindex]="active ? 0 : -1"
  type="button"
  (click)="click.emit()"
  (keydown)="keydown.emit($event)"
>
  <ng-content></ng-content>

  <opac-badge *ngIf="badge !== undefined" [primary]="active">
    {{ badge }}
  </opac-badge>
</button>
